import React from 'react';
import { motion } from 'framer-motion';
import { Target, Users, TrendingUp, Shield, BarChart3, Globe } from 'lucide-react';
const pillars = [{
  icon: Target,
  title: 'Strategic Alignment',
  description: 'Bridging the gap between executive vision and operational execution to ensure every initiative drives core business goals.'
}, {
  icon: Users,
  title: 'Stakeholder Management',
  description: 'Expert navigation of complex organizational structures, building consensus across C-suite executives and cross-functional teams.'
}, {
  icon: TrendingUp,
  title: 'Operational Excellence',
  description: 'Optimizing processes and workflows to maximize efficiency, reduce waste, and accelerate time-to-market for critical products.'
}, {
  icon: Shield,
  title: 'Risk Mitigation',
  description: 'Proactive identification and management of program risks, ensuring stability and compliance in high-stakes environments.'
}, {
  icon: BarChart3,
  title: 'Data-Driven Decisions',
  description: 'Leveraging advanced analytics and KPIs to provide transparent reporting and actionable insights for leadership.'
}, {
  icon: Globe,
  title: 'Global Transformation',
  description: 'Leading large-scale digital transformation initiatives across multiple geographies and cultural contexts.'
}];
export function ValuePillars() {
  return <section id="pillars" className="py-20 bg-[#FDFBF7]" data-id="element-312">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-313">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-314">
          <h2 className="text-2xl md:text-3xl font-bold text-corporate-blue mb-4" data-id="element-315">
            Strategic Value Proposition
          </h2>
          <p className="text-base text-[#6B6356] max-w-2xl mx-auto" data-id="element-316">
            Delivering comprehensive program management solutions that drive
            sustainable growth and organizational resilience.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-317">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl border border-[#E8E0D0] shadow-sm hover:shadow-md transition-shadow group" data-id="element-318">
              <div className="w-12 h-12 bg-corporate-teal/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-corporate-teal/20 transition-colors" data-id="element-319">
                <pillar.icon className="text-corporate-teal" size={24} data-id="element-320" />
              </div>
              <h3 className="text-lg font-bold text-corporate-blue mb-2" data-id="element-321">
                {pillar.title}
              </h3>
              <p className="text-[#6B6356] leading-relaxed text-sm" data-id="element-322">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}